export const CREDIT_CARD = 'CREDIT_CARD';
export const AMAZON_PAY = 'AMAZON_PAY';
export const AFTER_PAY = 'AFTER_PAY';
